import { MsgLevel } from './MsgLevel';
import { BaseConst } from '../BaseConst';
import { BaseInjectProxy } from '../BaseInjectProxy';
import { BaseInjectProxyImpl } from '../BaseInjectProxyImpl';

/**
 * 基盤Controller
 */
export abstract class BaseController {

    /**
     * フレームワークで使用するサービスのプロキシ
     */
    public PATTERN_NUMBER: string = 'pattern=/^[0-9]*$/:alt=半角数字を入力してください。';
    public PATTERN_SINGLE: string = 'pattern=/^[a-zA-Z0-9!-/:-@<C2><A5>[-`{-~]*$/:alt=半角文字を入力してください。';
    public PATTERN_PASSWORD: string = 'pattern=/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z\\d]{8,100}$/:alt=半角英小文字大文字数字をそれぞれ1種類以上含む8文字以上のパスワードを入力してください。';

    private baseInjectProxyImpl: BaseInjectProxyImpl;

    /**
     * コンストラクタ
     * パラメータでプロパティの定義を実施
     * @param {angular.ui.IStateParamsService} $stateParams UI Routerのパラメータ
     * @param {BaseInjectProxy} baseInjectProxy フレームワークで使用するサービス
     */
    constructor(protected $stateParams: angular.ui.IStateParamsService,
                protected $translate: ng.translate.ITranslateService,
                baseInjectProxy: BaseInjectProxy) {
        this.baseInjectProxyImpl = <BaseInjectProxyImpl> baseInjectProxy;
    }

    /**
     * 画面のタイトルを設定する
     * @param {string} title タイトル
     */
    protected setTitle(title: string): void {
        this.$translate(title).then((value: string) => {
            this.baseInjectProxyImpl.getRootScope()[BaseConst.SCOPE_TITLE] = value;
        });
    }

    /** 描画処理
     * カウンタのIDに合わせて処理を分岐
     * @param {any} history 履歴への追加するデータ 存在する場合は履歴へ追加
     */
    protected draw(history: any = null): void {
        if (this.$stateParams) {
            let fwts: string = this.$stateParams[BaseConst.PARAM_TIMESTAMP];
            if (fwts) {
                // 存在する場合、画面のリストア
                this.getHistory(fwts).then((response: string) => {
                    if (response) {
                        this.restore(response);
                    } else {
                        this.show();
                        if (history) {
                            this.addHistory(fwts, history);
                        }
                    }
                });
            } else {
                // 存在しない場合は、通常の表示
                this.show();
            }
        } else {
           this.show();
        }
    }

    /**
     * UI Routerの画面遷移のラッパー
     * （カウンターの埋め込みを実施）
     * @param {string} state 遷移先の状態
     * @param {any} params パラメータ
     */
    protected go(state: string, params: any = {}): void {
        params[BaseConst.PARAM_TIMESTAMP] = new Date().getTime();
        this.baseInjectProxyImpl.getState().go(state, params);
    }

    /**
     * 現在の画面遷移のステータス名を取得する
     * @return {string} ステータス名
     */
    protected getCurrentStatus(): string {
        return this.baseInjectProxyImpl.getState().current.name;
    }

    /**
     * 画面の表示内容を復元する
     * @param {any} data 復元に使用するデータ
     */
    protected abstract restore(data: any): void;

    /**
     * 画面の表示処理を実装
     */
    protected abstract show(): void;

    /**
     * 履歴へ記録する処理
     * @param {string} timestamp タイムスタンプ
     * @param {any} data 記録するデータ
     */
    protected abstract addHistory(timestamp: string, data: any): void;

    /** 履歴を取得する処理
     * @param {string} timestamp タイムスタンプ
     * @return {ng.IPromise} 履歴から取得したデータ
     */
    protected abstract getHistory(timestamp: string): ng.IPromise<string>;
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/controller/BaseController.ts
 **/